"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SenderAddress = void 0;
let SenderAddress = exports.SenderAddress = void 0;
(function (_SenderAddress) {
  let Type = /*#__PURE__*/function (Type) {
    Type["CUSTOM"] = "custom";
    Type["PREZLYMAIL"] = "prezly_mail";
    return Type;
  }({});
  _SenderAddress.Type = Type;
})(SenderAddress || (exports.SenderAddress = SenderAddress = {}));